import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Company } from '@app/models';
import { CompanyService, Toaster } from '@app/services';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { LocalStorage } from 'ngx-webstorage';

@Component({
  selector: 'ngx-company',
  styleUrls: ['./company.style.scss'],
  templateUrl: './company.component.html',
})
export class CompanyComponent implements OnInit {
  @LocalStorage() organizationId: string;
  isRCDSS = environment.name === 'rcdss';
  selectedIndexTab = 0;

  company: Company = new Company();
  
  loading: boolean = false;

  constructor(
    private location: Location,
    private $company: CompanyService,
    public router: Router,
    private $toaster: Toaster,
  ) {
  }

  ngOnInit(): void {
    this.getCompany(this.organizationId);
  }

  getCompany(id: string) {
    this.loading = true;
    this.$company.getById(id).subscribe(
      company => {
        this.loading = false;
        this.company = company;
      },
      error => {
        console.error('ERROR Fetching Company', error);
        this.$toaster.show('error', 'Error', 'Error loading the company details');
      },
    );
  }

}
